import { createSelector } from 'reselect';
import { orderOptions } from './LeadsConsts';

export const leadsState = state => (
  state.Leads
);

export const leadsList = createSelector(
  leadsState,
  state => state.Leads,
);

export const totalAssets = createSelector(
  leadsState,
  state => state.TotalAssets,
);

export const totalLeads = createSelector(
  leadsState,
  state => state.TotalLeads,
);

export const nextPage = createSelector(
  leadsState,
  state => state.nextPage,
);

export const sortBy = createSelector(
  leadsState,
  state => state.sortBy,
);

export const orderBy = createSelector(
  leadsState,
  state => state.orderBy,
);

export const showPagination = createSelector(
  leadsState,
  (state) => {
    const { currentPage, totalPages } = state;
    return currentPage !== totalPages;
  },
);

export const nextOrderBy = createSelector(
  leadsState,
  (state) => {
    const {
      asc,
      desc,
    } = orderOptions;
    return state.orderBy === asc ? desc : asc;
  },
);
